<template>
  <h1 >Rogue Transaction [
  <router-link
  :to="{ name: 'ViewOrder', params: { id: currentRogueId } }"  class="white"
  target="_blank"
>{{currentRogueId}}</router-link> - 
<router-link
  :to="{ name: 'ViewCustomer', params: { id: orderDetails.customer_id } }"
  target="_blank"  class="white"
>{{ orderDetails.customername }}</router-link>
  ]</h1>
  <div id="page-rfid-dashboard" class="content-section">
    <div class="page-section">

      <div class="row">
          <div class="col-md-3">
            <div>
              <FormKit
                  type="button"
                  label="Go Back"
                  input-class="$reset btn-rfid-xsm btn btn-rfid btn-associate btn-goback"
                  @click="goTo('Dashboard')"
                  prefix-icon="arrowLeft"
                  prefix-icon-class="btn-rfid-back"
              />
            </div>
          </div>
        </div>


      <div class="clearfix"></div>

      <div class="content-section">
       
        <div>
          <easy-data-table
              :headers="headers"
              :items="rogueItems"
              :search-field="searchField"
              :search-value="searchValue"
              :loading="loading"
              alternating
              border-cell
              multi-sort
              :body-row-class-name="getRowClass"
          >
         
          <template #header-select>
            <input
              type="checkbox"
              :checked="selectedItems.length === rogueItems.length && rogueItems.length > 0"
              @change="toggleSelectAll"
              title="Select All"
            />
          </template>

          <template #item-select="item">
            <input
              type="checkbox"
              :value="item.id"
              v-model="selectedItems"
              :data-maintype-id="item.garment?.garmenttype?.maintype_id ?? 0"
              :disabled="item.resolved_at !== null"
            />
          </template>
          <template #item-created_at="{ created_at }">
              <div > {{formatFullDateEN(created_at)}}</div>
          </template>
          <template #item-garment.customer="item">
            <router-link target="_blank"  v-if="item.garment?.customer && item.garment.customer.customer_id" :to="{ name: 'ViewCustomer', params: { id: item.garment.customer.customer_id } }">
                <div > {{ item.garment.customer.first_name }} {{ item.garment.customer.last_name }}</div>
              </router-link>
            </template>
         <!--<template #item-epc_value="{ item }">
              <div > {{ item.garment?.rfid_value }}</div>
            </template>

            <template #item-garment_type="{ item }">
              <div > {{item.garment.garmenttype.garment_type }}</div>
            </template>
           
             <template #item-customer_id="{ item }">
              <router-link target="_blank" :to="{ name: 'ViewCustomer', params: { id: item.garment.customer.customer_id } }">
                <div > {{ item.garment.customer.first_name }} {{ item.garment.customer.last_name }}</div>
              </router-link>
            </template>-->  

            <template #loading>
              <font-awesome-icon
                  icon="spinner"
                  size="2x"
                  title="Loading"
                  spin
              >
              </font-awesome-icon>
            </template>
          </easy-data-table>
        </div>
      </div>

      <div class="clearfix"></div>

       <div class="content-section">
        <div class="row">
          
          <div class="col-md-4 center-btn">
            <div>
              <FormKit
                  type="button"
                  label="Add to order"
                    input-class="$reset btn-rfid-lg btn btn-rfid btn-re-assign"
                    @click="addToOrder"
              />
            </div>

          </div>

          <div class="col-md-4 center-btn">
            <div>
              <FormKit
                  type="button"
                  label="Overwrite and Add to order"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-associate"
                  @click="overwriteAndAddToOrder"
              />
            </div>
          </div>
          <div class="col-md-4 center-btn">
            <div>
              <FormKit
                  type="button"
                  label="Reject at folding"
                  input-class="$reset btn-rfid-lg btn btn-rfid btn-assemble"
                  @click="rejectAtFolding"
              />
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>

    <div class="modal" tabindex="-1" id="actionsRogueModal" ref="actionsRogueModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span v-if="modalAction === 'addToOrder'">Add to Order</span>
            <span v-if="modalAction === 'overwriteAndAddToOrder'">Overwrite and Add to Order</span>
            <span v-if="modalAction === 'flagToFolding'">Flag to Folding</span>
            <span v-if="modalAction === 'actionResponse'">{{ actionResponseTitle }}</span>
            <span v-if="modalAction === 'managerOverwrite'">Overwrite</span>
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="content-section">
            
            <div 
              v-if="errorMessage || successMessage"
              class="alert"
              :class="errorMessage ? 'alert-danger' : 'alert-success'"
              role="alert"
              >
                <span v-if="errorMessage">{{ errorMessage }}</span>
                <span v-if="successMessage">{{ successMessage }}</span> 
            </div>
            

            <div v-if="modalAction === 'addToOrder'">
              <div>Selected items have the master type as <label class="highlight-info">{{ masterType }}</label></div>

              <div>
                Please select the price when adding to this order:
                <FormKit
                    v-model="garmentTypeId"
                    type="autocomplete"
                    name="garmentTypeId"
                    id="garmentTypeId"
                    label="Select Garment"
                    placeholder="Select Garment"
                    :options="accountGarments"
                    :value="garmentTypeId"
                    open-on-click
                    clear-search-on-open
                    searchable
                    @input="onGarmentChange"
                />
                <FormKit
                    v-if="serviceTypeOptions.length > 0"
                    v-model="serviceTypeId"
                    type="select"
                    name="serviceTypeId"
                    id="serviceTypeId"
                    label="Select Service"
                    placeholder="Select Service"
                    :options="serviceTypeOptions"
                    @input="onServiceTypeChange"
                />
                <div v-if="selectedGarmentPrice && selectedGarmentPrice">
                  <div>Selected price: <label class="highlight-info">£{{ selectedGarmentPrice }}</label></div>
                </div>
              </div>
            </div>
            <div v-if="modalAction === 'overwriteAndAddToOrder'">
              <p>Available garments to overwrite, continue? </p>
              <FormKit
                  v-model="garmentTypeId"
                  type="autocomplete"
                  name="garmentTypeId"
                  id="garmentTypeIdOverwrite"
                  label="Select Garment"
                  placeholder="Select Garment"
                  :options="accountGarments"
                  :value="garmentTypeId"
                  open-on-click
                  clear-search-on-open
                  searchable
                  @input="onGarmentChange"
              />
              <FormKit
                  v-if="serviceTypeOptions.length > 0"
                  v-model="serviceTypeId"
                  type="select"
                  name="serviceTypeIdOverwrite"
                  id="serviceTypeIdOverwrite"
                  label="Select Service"
                  placeholder="Select Service"
                  :options="serviceTypeOptions"
                  @input="onServiceTypeChange"
              />
            </div>
            <div v-if="modalAction === 'flagToFolding'">
                <p>The selected towels will be flagged at Towel Folding Station.</p>
            </div>
            <div v-if="modalAction === 'actionResponse'">
              <p>{{ actionResponseMessage }}</p>        
            </div>
            
            <div v-if="modalAction === 'managerOverwrite'">
              <FormKit
                  v-model="uniquepw"
                  type="password"
                  name="uniquepw"
                  id="uniquepw"
                  label="Enter Pin"
                  placeholder="Pin"
                  validation="required"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="modalAction === 'addToOrder'">
            <button type="button" class="btn btn-bundling mr-5" data-bs-dismiss="modal">Go back</button>
            <button  type="button" class="btn btn-primary btn-assemble" @click="addToOrderAction">Add</button>
          </div>
          <div v-if="modalAction === 'overwriteAndAddToOrder'">
            <button type="button" class="btn btn-bundling mr-5" data-bs-dismiss="modal">Go back</button>
            <button  type="button" class="btn btn-primary btn-assemble" @click="managerOverwrite">Overwrite</button>
          </div>
          <div v-if="modalAction === 'managerOverwrite'">
            <button type="button" class="btn btn-assemble mr-5" data-bs-dismiss="modal">Cancel</button>
            <button  type="button" class="btn btn-primary btn-bundling" @click="managerConfirmation">Submit</button>
          </div>
          <div v-if="modalAction === 'flagToFolding'">
            <button type="button" class="btn btn-bundling mr-5" data-bs-dismiss="modal">Go back</button>
            <button  type="button" class="btn btn-primary btn-assemble" @click="flagToFoldingAction">Flag To Folding</button>
          </div>
          <div v-if="modalAction === 'actionResponse'">
            <button type="button" class="btn btn-bundling" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>


<script setup>

import {onMounted, ref, inject, reactive, watch, computed} from 'vue'
import { useRouter } from 'vue-router'
import 'bootstrap/dist/css/bootstrap.min.css';
import RFIDService from "@/services/RFIDService";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle";
import { formatLondon, formatFullDateEN, formatDateEN } from '@/utils/dateUtils';
import { openModal, closeModal } from '@/utils/modalUtils';
import OrderService from '@/services/OrderService';
import VueCookies from "vue-cookies";
import GarmentTypeService from '@/services/GarmentTypeService';

const router = useRouter();

const currentRogueId = parseInt(router.currentRoute.value.params.id);

const rogueItems =  ref([]);
const headers = [
  { text: "", value: "select", sortable: false }, // Checkbox column
  { text: "EPC", value: "rfid_value", sortable: true },
  { text: "Garment ID", value: "garment.tag_value", sortable: true },
  { text: "Account Name", value: "garment.customer", sortable: true },
  { text: "Garment type", value: "garment.garmenttype.garment_type", sortable: true },
  { text: "Timestamp Scanned", value: "created_at", sortable: true  },
  
  
];
const searchField = ref("created_at");
const searchValue = ref("");

const loading = ref(false);

const orderDetails = ref({});
const orderItems = ref([]);
const serverItemsLength = ref(0);
const selectedItems = ref([]);
const actionsRogueModal = ref(null);
const modalAction = ref(null);
const actionResponseMessage = ref("");
const actionResponseTitle = ref("");
const errorMessage = ref(false);
const successMessage = ref(false);
const uniquepw = ref("");

const garmentTypeId = ref(0);
const serviceTypeId = ref(0);
const serviceTypeOptions = ref([]);
const accountGarments = ref([]);
const masterType = ref("");
const selectedGarmentPrice = ref(null);

const resetServiceTypeSelection = () => {
  serviceTypeId.value = 0;
  serviceTypeOptions.value = [];
  selectedGarmentPrice.value = null;
};

//highlight the row if resolved_at is not null
const getRowClass = (item) => {
  return item.resolved_at !== null ? 'table-success' : '';
};


function toggleSelectAll(event) {
  if (event.target.checked) {
    selectedItems.value = rogueItems.value
      .filter(item => item.resolved_at === null) // only not disabled
      .map(item => item.id);
  } else {
    selectedItems.value = [];
  }
}

const goTo = (pageSection) =>   {
  switch (pageSection) {
    case "Dashboard":
      window.open(
          "/rfid/rogue-gallery",
          "_self"
      );
      break;
  }
}
//check if all selected items have the same data-maintype-id value
const checkMainType =  () => {
  // Get all selected items from rogueItems by their id
  const selected = rogueItems.value.filter(item => selectedItems.value.includes(item.id));
  // Get maintype_id for each selected item (default to 0 if missing)
  const maintypeIds = selected.map(item => item.garment?.garmenttype?.maintype_id ?? 0);
  // Check if all maintypeIds are the same
  const allSame = maintypeIds.every(id => id === maintypeIds[0]);
  if (!allSame) {
    return false;
  }

  return true;
};

 //check to see if is selected items don't contains Non-Associated Garment
const hasNonAssociatedGarment = computed(() => {
  // Get all selected items from rogueItems by their id
  const selected = rogueItems.value.filter(item => selectedItems.value.includes(item.id));
  // Return true if any selected item has garment_id == null
  return selected.some(item => item.garment_id == null || item.garment_id === 0);
});

//check if any item is selected
const hasSelection = computed(() => selectedItems.value.length > 0);

// Get unique garment types from orderItems
const uniqueGarmentTypes = computed(() => {
  const seen = new Set();
  return orderItems.value.filter(item => {
    if (!item.garment_type_id) return false;
    if (seen.has(item.garment_type_id)) return false;
    seen.add(item.garment_type_id);
    return true;
  });
});
//array of unique maintype_id values from the currently selected items.
const uniqueSelectedMaintypeIds = computed(() => {
  const seen = new Set();
  return rogueItems.value
    .filter(item => selectedItems.value.includes(item.id))
    .map(item => item.garment?.garmenttype?.maintype_id ?? 0)
    .filter(id => {
      if (seen.has(id)) return false;
      seen.add(id);
      return true;
    });
});

// When user click Add to Order button
const addToOrder =  () => {
  modalAction.value = "addToOrder";
  errorMessage.value = "";
  successMessage.value = "";
  //reset garmentTypeId
  garmentTypeId.value = 0;
  resetServiceTypeSelection();
  //need to select at least one item
  if (!hasSelection.value) {
    errorMessage.value = "Please select at least one item.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    openModal(actionsRogueModal);
    return;
  }
  //check if has the same maintype_id
  if (!checkMainType()) {
    errorMessage.value = "The selection of rogue items cannot be resolved with the selected choice.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    openModal(actionsRogueModal);
    return;
  }

  //check to see if is selected items don't contains Non-Associated Garment
  if (hasNonAssociatedGarment.value) {
    errorMessage.value = "Selection contains Non-Associated Garment(s). Please select only associated garments.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    openModal(actionsRogueModal);
    return;
  }

  //get unique maintype_id from selected Items
  //load only the order customer garments that have the same master type id as selected ones
  if (uniqueSelectedMaintypeIds.value.length > 0) {
   
    loadAccountGarments(uniqueSelectedMaintypeIds.value[0]);

    GarmentTypeService.getGarmentType(uniqueSelectedMaintypeIds.value[0])
      .then(response => {
        console.log("Garment Type Response:", response.data);
        if (response.data.status === "OK") {
          masterType.value = response.data.data.garment_type.garmenttype;
        } else {
          masterType.value = "Unknown";
        }
      })
      .catch(e => {
        masterType.value = "Unknown";
        console.log(e);
      });
  }
   openModal(actionsRogueModal);
};


const onGarmentChange = (garmenttypeId) => {
  resetServiceTypeSelection();

  if (!garmenttypeId || garmenttypeId === '0') {
    return;
  }

  GarmentTypeService.getFilteredServicePrices(garmenttypeId)
      .then(response => {
        if (response.data.success === true) {
          const servicePrices = response.data.data.service_prices || [];
          const options = servicePrices.map((service) => ({
            label: service.service_type_label,
            value: service.service_type_id,
            price: service.priceband_standard,
          }));

          if (options.length === 1) {
            serviceTypeId.value = options[0].value;
            selectedGarmentPrice.value = options[0].price;
            serviceTypeOptions.value = options;
          } else if (options.length > 1) {
            options.unshift({
              label: ' - select service - ',
              value: 0,
              price: null,
            });
            serviceTypeOptions.value = options;
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
};

const onServiceTypeChange = (selectedServiceTypeId) => {
  const selected = serviceTypeOptions.value.find(
    (option) => Number(option.value) === Number(selectedServiceTypeId)
  );
  selectedGarmentPrice.value = selected ? selected.price : null;
};

// When user add the garment master type and click on Add button
const addToOrderAction =  () => {
  if (serviceTypeOptions.value.length > 1 && !serviceTypeId.value) {
    errorMessage.value = "Please select a service.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    return;
  }

  modalAction.value = "actionResponse";
  errorMessage.value = "";
  successMessage.value = "";
  
  //let selectedItemsStr = selectedItems.value.join(",");
  RFIDService.resolveRogueItems(
              router.currentRoute.value.params.id, 
              selectedItems.value,
              garmentTypeId.value,
              null,
              "add",
              serviceTypeId.value || null
            )
                .then(response => {

                  if (response.data.success === true) {
                    successMessage.value = "Rogue items added to order successfully.";
                    modalAction.value = "actionResponse";
                    actionResponseTitle.value = "Success";

                    //reload the item list
                    selectedItems.value = [];
                    loadRFIDrogueItems();
                  } else {
                    errorMessage.value = "Error adding to order.";
                    modalAction.value = "actionResponse";
                    actionResponseTitle.value = "Error";
                  }
                  
                })
                .catch(e => {
                  modalAction.value = "actionResponse";
                  actionResponseTitle.value = "Error";
                  errorMessage.value = "Error adding to order.";
                  console.log(e);
                });
};

// When user click Overwrite and Add to Order button
// user need to select the garment master type  
const overwriteAndAddToOrder =  () => {
  modalAction.value = "overwriteAndAddToOrder";
  errorMessage.value = "";
  garmentTypeId.value = 0;
  resetServiceTypeSelection();
  successMessage.value = "";
  if (!hasSelection.value) {
    errorMessage.value = "Please select at least one item.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    openModal(actionsRogueModal);
    return;
  }
  if (!checkMainType()) {
    errorMessage.value = "The selection of rogue items cannot be resolved with the selected choice.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    openModal(actionsRogueModal);
    return
  }
  if (uniqueSelectedMaintypeIds.value.length > 0) {
   
    loadAccountGarments(uniqueSelectedMaintypeIds.value[0]);
  } else {
      loadAccountGarments();
  }

  openModal(actionsRogueModal);
};

// When user click Manager Overwrite button, after selecting garment master type 
// need to add the confirmation pin of Manager (the pin for any manager)
const managerOverwrite =  () => {
  modalAction.value = "managerOverwrite";
  errorMessage.value = "";
  successMessage.value = "";
  openModal(actionsRogueModal);
};

// When user add the manager Pin and click on Confirmation button
// if pin is valid then need to Overwrite and Add to Order button
const managerConfirmation =  () => {
  if (serviceTypeOptions.value.length > 1 && !serviceTypeId.value) {
    errorMessage.value = "Please select a service.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    return;
  }

  console.log("garmentTypeId",garmentTypeId.value);
  modalAction.value = "managerConfirmation";
  errorMessage.value = "";
  successMessage.value = "";
  
  let epos_userid = VueCookies.get('epos2_userid');
    RFIDService.checkManagerByPin(epos_userid, uniquepw.value)
      .then(response => {
        if (response.data.success === true) {
            //let selectedItemsStr = selectedItems.value.join(",");
            //(order_id, rogue_item_ids, garment_type_id, manager_pin, action) {
            RFIDService.resolveRogueItems(
              router.currentRoute.value.params.id, 
              selectedItems.value,
              garmentTypeId.value,
              uniquepw.value,
              "overwrite",
              serviceTypeId.value || null
            )
                .then(response => {

                  if (response.data.success === true) {
                    successMessage.value = "Rogue items overwritten and added to order successfully.";
                    modalAction.value = "actionResponse";
                    actionResponseTitle.value = "Success";

                    //reload the item list
                    selectedItems.value = [];
                    loadRFIDrogueItems();
                  } else {
                    errorMessage.value = response.data.message || "Error overwriting and adding to order.";
                    modalAction.value = "actionResponse";
                    actionResponseTitle.value = "Error";
                  }
                  
                })
                .catch(e => {
                  modalAction.value = "actionResponse";
                  actionResponseTitle.value = "Error";
                  errorMessage.value = e.response?.data?.message || "Error overwriting and adding to order.";
                  console.log(e);
                });

          
        } else {
          modalAction.value = "actionResponse";
          actionResponseTitle.value = "Error";
          console.log("Incorrect Manager Pin");
          errorMessage.value = response.data.message || "Incorrect Pin";
          return false
        }
      })
      .catch(e => {
        modalAction.value = "actionResponse";
        actionResponseTitle.value = "Error";
        errorMessage.value = e.response?.data?.message || "Incorrect Pin";
        console.log(e);
        return false
      });
};



// When user click Flag to Folding button
const flagToFolding =  () => {
  modalAction.value = "flagToFolding";
  successMessage.value = "";
  errorMessage.value = "";
  if (!hasSelection.value) {
    errorMessage.value = "Please select at least one item.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
  }
  openModal(actionsRogueModal);
};

const rejectAtFolding = () => {
  errorMessage.value = "";
  successMessage.value = "";

  if (!hasSelection.value) {
    errorMessage.value = "Please select at least one item.";
    modalAction.value = "actionResponse";
    actionResponseTitle.value = "Error";
    openModal(actionsRogueModal);
    return;
  }

  RFIDService.rejectRogueItemsAtFolding(router.currentRoute.value.params.id, selectedItems.value)
    .then(response => {
      modalAction.value = "actionResponse";

      if (response.data.success === true) {
        successMessage.value = "Selected rogue items were rejected at folding successfully.";
        actionResponseTitle.value = "Success";
        selectedItems.value = [];
        loadRFIDrogueItems();
      } else {
        errorMessage.value = response.data.message || "Error rejecting rogue items at folding.";
        actionResponseTitle.value = "Error";
      }

      openModal(actionsRogueModal);
    })
    .catch(e => {
      modalAction.value = "actionResponse";
      actionResponseTitle.value = "Error";
      errorMessage.value = e.response?.data?.message || "Error rejecting rogue items at folding.";
      openModal(actionsRogueModal);
      console.log(e);
    });
};

// When user click Flag to Folding button
const flagToFoldingAction =  () => {
  modalAction.value = "actionResponse";
  errorMessage.value = "";
  successMessage.value = "Successfully flagged at Towel Folding Station.";
  actionResponseTitle.value = "Success";
};

const loadAccountGarments = async (masterTypeID = false) => {
 RFIDService.getAccountGarmentType(orderDetails.value.customer_id)
      .then(response => {
        let garments = response.data.data.garmentstype;
        console.log("loadAccountGarments Master Type ID:", masterTypeID);
        // If masterTypeID > 0, filter garments by master type
        if (masterTypeID && masterTypeID > 0) {
          garments = garments.filter(
            g => g.garment_details.maintype_id === masterTypeID
          );
        }
        
        if (garments.length == 0) {
          accountGarments.value = [];
        } else {
          const newGarments = garments.map((g) => ({
            label: g.garment_details.garmenttype,
            value: g.garmenttype_id,
            default_price: g.garment_details.default_price 
          }));
          newGarments.unshift({
            label: " - select garment - ",
            value: "0",
            default_price: 0
          });   
          accountGarments.value = newGarments;
        }

      })
      .catch(e => {
        console.log(e);
      });
}

const loadRFIDrogueItems = async () => {

  //console.log('get logs');
  loading.value = true;
  const {
    serverCurrentPageItems,
  } = await RFIDService.getRFIDRogueOrderItems(router.currentRoute.value.params.id);
  rogueItems.value = serverCurrentPageItems;
// console.log('rogueItems', rogueItems.value);
  loading.value = false;
}
const loadOrderDetails = async () => {
  try {
    const orderDetailsResponse = await OrderService.getOrder(parseInt(router.currentRoute.value.params.id));
   // console.log("Order Details:", orderDetailsResponse);
    if (orderDetailsResponse.data.success == true) {
      orderDetails.value = orderDetailsResponse.data.data.orders[0];
       console.log("Order Details Value:", orderDetails.value);
    }
  } catch (error) {
    console.error("Error loading order details:", error);
  }
};
const loadOrderItems = async () => {

  //console.log('get logs');
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await OrderService.loadOrderItems(router.currentRoute.value.params.id);
  orderItems.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
  console.log("Loading order items...", orderItems.value);
}

onMounted(async () => {
  actionsRogueModal.value = new bootstrap.Modal('#actionsRogueModal', {})
  await loadRFIDrogueItems();
  await loadOrderDetails();
  await loadOrderItems();
});

</script>

<style>
.table-success td {
  background-color: #d4edda !important;
}
</style>

<style scoped>
a.white {
  color: white;
  text-decoration: underline;
  font-weight: bold;
}
.main-section > h1:first-child {
  background: var(--associate-tag-bg-color);
}
.error-message {
  color: var(--red-color);
  font-weight: bold;
}
.center-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.highlight-info {
    display: inline-block;
    border: solid 1px;
    padding: 3px 5px;
}
</style>
